// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"Delete_ModalContainer__2dL69","ModalContent":"Delete_ModalContent__3YXW4","ModalActions":"Delete_ModalActions__3y5B_","ModalButton":"Delete_ModalButton__1wzyF"};